import { OrgContext } from "contexts/OrgContext";
import React, { useContext, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

export const LaunchablesRedirect: React.FC = () => {
  const router = useHistory();
  const location = useLocation();
  const orgContext = useContext(OrgContext);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (!params.has("tab")) {
      params.set("tab", "explore");
    }

    router.push({
      pathname: `/org/${orgContext.activeOrgId}/launchables`,
      search: `?${params.toString()}`,
      hash: location.hash,
    });
  }, [location.hash, location.search, orgContext.activeOrgId, router]);

  return <></>;
};
